"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldNumberSagUtil = exports.CollectionModelFieldNumber = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var catenary_1 = require("../../../math/catenary");
var unit_1 = require("../../../unit");
var collection_field_1 = require("../collection.field");
var number_field_mutator_1 = require("./number.field.mutator");
var CollectionModelFieldNumber = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldNumber, _super);
    function CollectionModelFieldNumber() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this._Mutator = new number_field_mutator_1.ModelMutatorNumber(_this);
        return _this;
    }
    /** Type guard verify a field is of type number */
    CollectionModelFieldNumber.isNumberField = function (f) {
        return f.schema.type === CollectionModelFieldNumber.TYPE;
    };
    Object.defineProperty(CollectionModelFieldNumber.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new number_field_mutator_1.ModelMutatorNumber(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldNumber.prototype, "value", {
        /**
         * Calculate the value of the number field based off the provider type
         * @returns Raw number value.
         */
        get: function () {
            if (this.stateValue == null) {
                return null;
            }
            if (this.isManual()) {
                return this.stateValue.value;
            }
            if (this.isBackBearing()) {
                var capture = this.collection.state.getCapture(this.stateValue.captureId);
                return unit_1.IkeAngle.normalize(capture.orientation.bearing + Math.PI);
            }
            if (this.isBearing()) {
                var capture = this.collection.state.getCapture(this.stateValue.captureId);
                return unit_1.IkeAngle.normalize(capture.orientation.bearing);
            }
            if (this.isSag()) {
                var sagResult = CollectionModelFieldNumberSagUtil.getSag(this);
                if (sagResult == null || isNaN(sagResult.maxSag)) {
                    return 0;
                }
                return sagResult.maxSag;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldNumber.prototype, "displayValue", {
        get: function () {
            if (this.isManual()) {
                if (isNaN(this.value) || typeof this.value !== 'number') {
                    return '';
                }
                return String(unit_1.IkeUnit.round(this.value, unit_1.IkeUnit.DECIMALS));
            }
            if (this.isBackBearing() || this.isBearing()) {
                var degrees = unit_1.IkeUnit.convertAngle(this.value, unit_1.IkeUnit.DEGREE, unit_1.IkeUnit.RADIAN);
                return String(unit_1.IkeUnit.round(degrees, unit_1.IkeUnit.DECIMALS));
            }
            if (this.isSag()) {
                var sagResult = CollectionModelFieldNumberSagUtil.getSag(this);
                if (sagResult == null) {
                    return '0';
                }
                return String(unit_1.IkeUnit.round(sagResult.maxSag, unit_1.IkeUnit.DECIMALS));
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldNumber.prototype, "provider", {
        /**
         * Get the provider type of the field.
         * Defaults to 'manual' if no provider is defined.
         *
         * @returns Field provider type.
         */
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null || stateValue.provider == null) {
                return CollectionModelFieldNumber.PROVIDER_MANUAL;
            }
            return stateValue.provider;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldNumber.prototype.isManual = function () {
        return this.provider === CollectionModelFieldNumber.PROVIDER_MANUAL;
    };
    CollectionModelFieldNumber.prototype.isBearing = function () {
        return this.provider === CollectionModelFieldNumber.PROVIDER_BEARING;
    };
    CollectionModelFieldNumber.prototype.isBackBearing = function () {
        return this.provider === CollectionModelFieldNumber.PROVIDER_BACK_BEARING;
    };
    CollectionModelFieldNumber.prototype.isSag = function () {
        return this.provider === CollectionModelFieldNumber.PROVIDER_SAG;
    };
    CollectionModelFieldNumber.prototype.getOwnedCaptures = function () {
        return this.getCaptures();
    };
    /**
     * All captures used by this field.
     * @returns List of captures
     */
    CollectionModelFieldNumber.prototype.getCaptures = function () {
        var _this = this;
        return this.getCaptureIds().map(function (c) { return _this.collection.state.getCapture(c); }).filter(function (c) { return !!c; });
    };
    CollectionModelFieldNumber.prototype.getOwnedCaptureIds = function () {
        return this.getCaptureIds();
    };
    CollectionModelFieldNumber.prototype.getCaptureIds = function () {
        if (this.isManual()) {
            return [];
        }
        if (this.stateValue == null) {
            return [];
        }
        if (this.isSag()) {
            return tslib_1.__spreadArray(tslib_1.__spreadArray([
                this.stateValue.start
            ], tslib_1.__read(this.stateValue.points), false), [
                this.stateValue.end
            ], false);
        }
        if (this.isBackBearing() || this.isBearing()) {
            return [this.stateValue.captureId];
        }
        return [];
    };
    /**
     * Whether this field's value is valid
     * @returns Whether the value is valid
     */
    CollectionModelFieldNumber.prototype.hasValue = function () {
        var value = this.value;
        if (value == null || isNaN(value)) {
            return false;
        }
        return true;
    };
    CollectionModelFieldNumber.PROVIDER_MANUAL = 'manual';
    CollectionModelFieldNumber.PROVIDER_BEARING = 'bearing';
    CollectionModelFieldNumber.PROVIDER_BACK_BEARING = 'backbearing';
    CollectionModelFieldNumber.PROVIDER_SAG = 'sag';
    CollectionModelFieldNumber.TYPE = core_api_1.IkeFieldType.NUMBER;
    return CollectionModelFieldNumber;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldNumber = CollectionModelFieldNumber;
var CollectionModelFieldNumberSagUtil = /** @class */ (function () {
    function CollectionModelFieldNumberSagUtil() {
    }
    CollectionModelFieldNumberSagUtil.getSag = function (field) {
        var captures = CollectionModelFieldNumberSagUtil.getSagCaptures(field);
        if (captures == null) {
            return null;
        }
        if (!captures.points[0]) {
            return null;
        }
        var sagOptimizer = catenary_1.CatSagOptimizer.fromCaptures(captures.start, captures.end, captures.points[0]);
        return sagOptimizer.getSag();
    };
    CollectionModelFieldNumberSagUtil.getSagCaptures = function (field) {
        if (!field.isSag()) {
            return null;
        }
        var stateValue = field.stateValue;
        var start = field.collection.state.getCapture(stateValue.start);
        var end = field.collection.state.getCapture(stateValue.end);
        var points = stateValue.points.map(function (captureId) { return field.collection.state.getCapture(captureId); }).filter(function (c) { return !!c; });
        return { start: start, end: end, points: points };
    };
    return CollectionModelFieldNumberSagUtil;
}());
exports.CollectionModelFieldNumberSagUtil = CollectionModelFieldNumberSagUtil;
//# sourceMappingURL=number.field.js.map